<template>
  <v-main v-if="loading || error">
    <app-loading :visible="loading"></app-loading>
    <div v-if="error" class="text-center ma-5">
      Não foi possivel carregar o comprovante
    </div>
  </v-main>
  <div v-else class="document">
    <document-header :account="name" description="Cashback<br><small>Pagamento de Fornecedor</small>"></document-header>
    <div class="container">
      <div class="row row-wrap">
        <div class="col-7">
          <div class="item-box">
            <div class="item-box-header"><h4>Conta Heppi</h4></div>
            <div class="item-box-content">
              <div class="row">
                <div class="col">
                  <h5>CPF/CNPJ</h5>
                  {{ document | document }}
                </div>
                <div class="col">
                  <h5>Conta Heppi</h5>
                  {{ heppiAccount }}
                </div>
              </div>
              <h5>Nome</h5>
              {{ name }}
            </div>
          </div>
        </div>
        <div class="col-5">
          <div class="item-box">
            <div class="item-box-header"><h4>Valor (R$)</h4></div>
            <div class="item-box-content text-center py-7">
              <div class="amount">
                {{ amount | priceInteger }}<small>,{{ amount | priceCents }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item-box mt-4">
        <div class="item-box-header"><h3>Detalhes do Cashback</h3></div>
        <div class="item-box-content">
          <div class="row">
            <div class="col-12 px-5 pb-0 pt-5">
              <h5>Descrição</h5>
              <div>{{ description }}</div>
            </div>
            <div class="col-4 px-5 pb-5 text-uppercase">
              <h5>Realizado em</h5>
              <div class="text-bold">
                {{ date | moment('DD MMM YYYY') }}
              </div>
            </div>
            <div class="col-4 px-5 pb-5 text-uppercase">
              <h5>Percentual</h5>
              <div>{{ percent }}%</div>
            </div>
            <div class="col-4 px-5 pb-5 text-uppercase">
              <h5>Valor da transferência</h5>
              <div>{{ transferValue | price }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import AppLoading from '@/components/Loading'
import documentHeader from '@/components/documentHeader'
import { mapGetters } from 'vuex'

export default {
  name: 'transfer',
  components: {
    AppLoading,
    documentHeader
  },
  data () {
    return {
      loading: false,
      error: false,
      name: '',
      heppiAccount: '',
      document: '',
      amount: 0,
      date: '2022-09-26',
      description: '',
      transferValue: 0,
      percent: 0
    }
  },
  computed: {
    ...mapGetters(['transactionById']),
    transactionId () {
      return (this.$route.query && this.$route.query.id) || null
    },
    transactionData () {
      return this.transactionId ? this.transactionById(this.transactionId) : null
    }
  },
  async created () {
    if (this.transactionData) {
      this.loading = true
      try {
        // sender
        const accountID = this.transactionData.account_id
        const account = await axios.get('accounts/' + accountID + '?api_key=' + accountID, { baseURL: 'https://payment-gateway-api.heppi.io/api/' })
        if (account.data) {
          this.name = account.data.name
          this.heppiAccount = account.data.account_number
          this.document = account.data.owner.document
        } else {
          this.error = true
        }
      } catch (error) {
        this.error = true
      }
      this.amount = this.transactionData.amount
      this.date = this.$moment(this.transactionData.payment_date.$date, 'YYYY-MM-DD[T]HH:mm[.000Z]').subtract(3, 'hours').format('YYYY-MM-DD HH:mm')
      this.description = this.transactionData.description
      this.transferValue = this.transactionData.cashback.total_amount
      this.percent = this.transactionData.cashback.percent
      this.loading = false
    }
    document.title = this.name + ' - cashback de pagamento de fornecedor - ' + this.$moment(this.date).format('DD-MM-YYYY')
  }
}
</script>
